<template>
  <!-- Header and Search -->
  <v-layout row wrap align-center justify-space-around class="primary" style="min-height:180px">
    <v-flex xs10 md5 class="mb-5 align-center">
      <v-icon size="35px" class="v-middle white--text">{{icon}}</v-icon>
      <span class="title white--text mx-3 mb-3 v-middle">{{title}}</span>
    </v-flex>
    <v-flex xs10 md5 class="mb-5" />
  </v-layout>
</template>

<script>
export default {
  props: {
    icon: { default: "" },
    value: { default: "" },
    title: { default: "" },
    showSearch: { default: true }
  },
  computed: {
    valueBind: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
